import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfigService} from '../common/service/app-config.service';
import {Observable, takeWhile, timer} from 'rxjs';
import {
    ExtractCadastreCreateExtractStatusResponse,
    ExtractCadastreCreateExtractRequest,
    ExtractCadastreCreateExtractResponse,
    ExtractCadastreParcelSearchRequest,
    ExtractCadastreParcelSearchResponse
} from './extract-cadastre.model';
import {switchMap} from 'rxjs/operators';
// TODO WADPL-1128 TEMP override stack - remove with common/fme-stack.ts.
import {fmeStackQuery} from '../common/fme-stack';

@Injectable({
    providedIn: 'root'
})
export class ExtractCadastreService {
    createExtractPollStart = 5000;

    createExtractPollInterval = 2000;

    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {}

    search(request: ExtractCadastreParcelSearchRequest): Observable<ExtractCadastreParcelSearchResponse> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/extract-cadastre/parcel-search';
        return this.http.post<ExtractCadastreParcelSearchResponse>(url, request);
    }

    createExtract(request: ExtractCadastreCreateExtractRequest): Observable<ExtractCadastreCreateExtractStatusResponse> {
        return this.createExtractJob(request).pipe(
            switchMap(response =>
                timer(this.createExtractPollStart, this.createExtractPollInterval).pipe(
                    switchMap(() => this.createExtractPoll(response.correlationId)),
                    takeWhile(statusResponse => statusResponse.status !== 'SUCCESS', true)
                )
            )
        );
    }

    private createExtractJob(request: ExtractCadastreCreateExtractRequest): Observable<ExtractCadastreCreateExtractResponse> {
        // TODO WADPL-1128 TEMP override stack - drop the fmeStackQuery() call.
        const url = this.appConfigService.settings.apiGatewayUrl + '/extract-cadastre/create-extract' + fmeStackQuery('?');
        return this.http.post<ExtractCadastreCreateExtractResponse>(url, request);
    }

    private createExtractPoll(correlationId: string): Observable<ExtractCadastreCreateExtractStatusResponse> {
        const url = `${this.appConfigService.settings.apiGatewayUrl}/extract-cadastre/create-extract/poll/${correlationId}`;
        return this.http.get<ExtractCadastreCreateExtractStatusResponse>(url);
    }
}
